
export default {
	currentUser: null,
	taxList: [],
}